import React from 'react'
import './Header.scss'
import {
  Col,
  Row,
} from 'reactstrap'

export default function () {
  return (
    <header className="Header">
      <Row className="justify-content-center align-items-center m-0">
        <Col className='image-container' xs={3}>
          <img className="shadow-lg img-fluid rounded-circle" src="/images/jane-hartenstein.png" alt="Jane Hartenstein"/>
        </Col>
        <Col>
          <div className="d-flex flex-column">
            <h1 className="h1 text-center mb-0 mt-4">Jane Hartenstein</h1>
            <p className="align-self-md-center text-center">Author, Speaker, and Mental Health
              Advocate</p>
          </div>
        </Col>
      </Row>
    </header>
  )
}
